import type { Company } from '@/types/Company'
import type { GetSuppliersParams } from '@/types/ForestOwners/Supplier'
import type { DetailedSuppliersResponse } from '@/types/Organization'
import { apiGet } from './ApiClient'
import { getMockSuppliers, isMockOrganization } from './MockOrganizationData'

export async function getCompany(organizationNumber: string): Promise<Company> {
  return apiGet<Company>(`/companies/${organizationNumber}`)
}

export interface CompanySuppliersDto {
  organizationNumber: string
  companyName: string
  supplierNumbers: number[]
}

export async function getCompanySuppliers(
  organizationNumber: string,
): Promise<CompanySuppliersDto> {
  return apiGet<CompanySuppliersDto>(
    `/companies/${encodeURIComponent(organizationNumber)}/suppliers`,
  )
}

export async function getSuppliersWithMunicipality(
  params: GetSuppliersParams,
): Promise<DetailedSuppliersResponse> {
  if (isMockOrganization(params.organizationNumber)) {
    const mockSupplierData = getMockSuppliers(params.organizationNumber)
    if (mockSupplierData) {
      return {
        organizationNumber: mockSupplierData.organizationNumber,
        companyName: mockSupplierData.companyName,
        suppliers: mockSupplierData.supplierNumbers.map((supplierNumber) => ({
          supplierNumber: supplierNumber.toString(),
          name: mockSupplierData.companyName,
          municipalityNumber: '3909',
          municipalityName: 'Larvik',
        })),
      }
    }
  } else {
    return await apiGet<DetailedSuppliersResponse>(
      `/companies/${encodeURIComponent(params.organizationNumber)}/suppliers/detailed`,
    )
  }

  return {
    organizationNumber: params.organizationNumber,
    companyName: '',
    suppliers: [],
  }
}
